import axios from '@fuse/utils/axios'

const getAllCompany = (params) => axios.get(`/company/fetch-company-suggestion?page=${params.page}${params.search ? `&search=${params.search}`: ''}`);

export {
    getAllCompany,
}
